import React, {useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Menu} from "antd";
import {Link} from "react-router-dom";
import {connect} from "react-redux";

const mapStateToProps = state => ({
    appLanguage: state.app.language,
});

const SidebarMenuItem = ({child, t, tReady, appLanguage, dispatch, ...other}) => {
    const translatedLabel = useMemo(() => {
        if (appLanguage && typeof child.label === "object") {
            return child.label[appLanguage];
        }
        return child.label;
    }, [appLanguage, child]);

    return (
        <Menu.Item key={child.path} className="sidebar__menu__sub__item" {...other}>
            <Link to={child.path}>
                <div className="sidebar__menu__sub__item__icon__container">
                    <img
                        alt={t(translatedLabel)}
                        className="sidebar__menu__sub__item__icon"
                        src={child.redIconPath}
                    />
                </div>
                {t(translatedLabel)}
            </Link>
        </Menu.Item>
    )
}

export default compose(translate(), connect(mapStateToProps))(SidebarMenuItem)